<div class="action-arrow__content" *ngIf="!canNotRetry">
	<button class="btn btn-sm cv-btn-blue" (click)="onRetryCall()">
		Retry
	</button>
</div>
